import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rsi_chart:false,
  stoch_chart:false,
  boll_chart:false,
  macd_chart:false,
  ema_7:false,
  ema_9:false,
  ema_12:false,
  ema_14:false,
  ema_21:false,
  ema_50:false,
  ema_200:false
};

const indicatorsPlotSlice = createSlice({
  name: 'indicatorsPlot',
  initialState,
  reducers: {   
    setRsi_chart: (state, action) => {
      state.rsi_chart = action.payload;
    },
    setStoch_chart: (state, action) => {
      state.stoch_chart = action.payload;
    },
    setBoll_chart: (state, action) => {
      state.boll_chart = action.payload;
    },    
    setMacd_chart: (state, action) => {
      state.macd_chart = action.payload;
    },
    setEma7: (state, action) => {
      state.ema_7 = action.payload;
    },
    setEma9: (state, action) => {
      state.ema_9 = action.payload;
    },
    setEma12: (state, action) => {
      state.ema_12 = action.payload;
    },
    setEma14: (state, action) => {
      state.ema_14 = action.payload;
    },
    setEma21: (state, action) => {
      state.ema_21 = action.payload;
    },
    setEma50: (state, action) => {
      state.ema_50 = action.payload;
    },
    setEma200: (state, action) => {
      state.ema_200 = action.payload;
    },
    
  }
});

export const { setRsi_chart, setStoch_chart, setBoll_chart, setMacd_chart, setEma7,setEma9, setEma12, setEma14, setEma21, setEma50, setEma200 } = indicatorsPlotSlice.actions;
export default indicatorsPlotSlice.reducer;